// extracted by mini-css-extract-plugin
export default {"holder":"Suggestions__holder--2lf","suggestions":"Suggestions__suggestions--BIB","spaceBetween":"Suggestions__spaceBetween--31s","center":"Suggestions__center--3AP"};